import React, {Component} from 'react';
import {getAllCountries} from "../../services/countryService"
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import Pagination from "../contents/Tables/pagination";
import CRUDTableOptions from "../contents/common/htmlElements/TableComponent/subTableComponents/CRUDTableOptions";
import ShowCountriesTable from "../contents/Tables/ShowCountriesTable";
import ButtonLink from "../contents/common/htmlElements/ButtonLink";
import httpService from "../../services/httpService";
import {getWorldRegionsList} from "../../services/worldregionsService";

class CountriesTableFrame100 extends Component {

    _isMounted = false;

    state = {
      locale : this.props.locale,
      isLoading : true,
      countriesList: {},
      worldRegionsList : {},
      filterString : "",
      NoWorldRegionsFound : false,
      pageSize:20,
      currentPage:1,
      showInactive : 1,
      sortColumn: { path: "id", order: "asc" },
      apiSummary:{
          totalElements:null,
          totalPages:null,
          currentPage:null,
          pageSize:null,
          elementsInCurrentPage:null
      }
    };


    componentDidMount() {
        this._isMounted = true;
        this.loadDataFromAPI(this.state.currentPage, this.state.pageSize, this.state.filterString);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    isEmptyObject(obj){
        for(var prop in obj) {
            if(obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    }

    loadDataFromAPI = async (currentPage, pageSize, filter) => {

        const language = this.props.locale;

        try{
            this.setState({ isLoading: true });
            const [{data : countriesList},{data: worldRegionsList} ] = await httpService.all([getAllCountries('id', "all", currentPage, pageSize, this.state.showInactive, filter ), getWorldRegionsList(language)])

            if (this._isMounted) {
                const summary = countriesList[0];
                countriesList.shift();
                this.setState({
                    apiSummary: summary,
                    countriesList : countriesList,
                    worldRegionsList : worldRegionsList,
                    isLoading : false
                });
                console.log(JSON.stringify(this.state.apiSummary))
            }

        }
        catch(err){
            if (this._isMounted) {
                this.setState({isLoading: false, NoUsersFound: true});
            }
        }
    };


    handlePageChange = page => {
        this.setState({ currentPage: page });
        this.loadDataFromAPI(page, this.state.pageSize, this.state.filterString)
    };

    handleFilterPage = string => {
        this.loadDataFromAPI(1, this.state.pageSize, string)
        this.setState({filterString: string})
    };

    handleSort = sortColumn => {
        this.setState({ sortColumn });
    };

    handlePageSize = pageSize => {
        this.setState({pageSize: parseInt(pageSize.target.value)})
        this.loadDataFromAPI(1, parseInt(pageSize.target.value), this.state.filterString)
    };


    render() {
        const count = this.state.apiSummary.totalElements == null ? 0 : this.state.apiSummary.totalElements;
        const pageSize = this.state.apiSummary.pageSize == null ? 0 : this.state.apiSummary.pageSize;
        const currentPage = this.state.apiSummary.currentPage == null ? 0 : this.state.apiSummary.currentPage;
        const { sortColumn, countriesList, worldRegionsList } = this.state;
        const pageSizeOptions = [1,2,3,20,50,100];
        const { formatMessage } = this.props.intl;
        const addNewLink =  "/" + this.state.locale + "/admin/configs/manage-countries/new";

        return (
            <div className="container">
                <div className="row" style={{marginTop:30}}>

                    <div className="col-md-12">
                        <CRUDTableOptions
                            itemCounts = {count}
                            OnPageFilter = {this.handleFilterPage}
                            OnPageSizeChange = {this.handlePageSize}
                            pageSize = {pageSize}
                            pageSizeOptions = {pageSizeOptions}
                            locale = {this.props.locale}
                        />

                        <ShowCountriesTable
                            itemCounts={count}
                            countriesList={countriesList}
                            worldRegionsList = {worldRegionsList}
                            sortColumn={sortColumn}
                            onSort={this.handleSort}
                            isLoading={this.state.isLoading}
                            locale = {this.props.locale}
                        />

                        <ButtonLink
                            link={addNewLink}
                            label={formatMessage({id:"countries.addNewButton"})}
                        />

                        <Pagination
                            itemsCount={count}
                            pageSize={pageSize}
                            currentPage={currentPage}
                            onPageChange={this.handlePageChange}
                            renderFullButtons={false}
                            isLoading={this.state.isLoading}
                        />
                    </div>

                </div>
            </div>
        );
    }
}

export default injectIntl(withRouter(CountriesTableFrame100));
